export const SVS_SUBJECT_MAP: { key: string; encrypted: string }[] = [
    { key: "CA", encrypted: "ML" },
    { key: "AC", encrypted: "KN" },
    { key: "AR", encrypted: "K]" },
    { key: "AL", encrypted: "KW" },
    { key: "BDR", encrypted: "LO^" },
    { key: "INV", encrypted: "Syb" },
    { key: "BS", encrypted: "L^" },
    { key: "TWMC", encrypted: "^bYP" },
    { key: "COINV", encrypted: "MZU[d" },
    { key: "RF", encrypted: "\\Q" },   // escaped backslash
    { key: "EC", encrypted: "ON" },
    { key: "JO", encrypted: "TZ" },
    { key: "NOC", encrypted: "XZO" },
    { key: "PA", encrypted: "ZL" },
    { key: "SC", encrypted: "]N" },
    { key: "SC", encrypted: "Y_TR`" }, // duplicate key, different encryption
];
